
import { useTranslation } from "react-i18next";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import { withTranslation } from 'react-i18next';
import React, {useEffect} from "react";
import {MainInfo} from "../../Components/Customer/CustomerComponents/MainInfo";
import commonActions from "../../Actions/commonActions";
import customerActions from "../../Actions/customerActions";
import CustomerInfoFlagsContainer from "./CustomerInfoFlagsContainer";
import {DefaultCard} from "../../Components/Card/Card";

export function MainInfoContainer({ customer, commonActions, toggleModal }) {
    const {t} = useTranslation();

    return <>
        <DefaultCard
            title={t("maininfocontainer.header")}
            headerContent={<CustomerInfoFlagsContainer onClick={toggleModal}/>}
            isLoading={!customer}>
            <MainInfo customer={customer}/>
        </DefaultCard>
    </>
}

function mapStateToProps(state) {
    return {
        customer: state.CustomerReducer.customer,
        customerForm: state.CommonReducer.forms && state.CommonReducer.forms.mainInfoFormData,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        customerActions: bindActionCreators(customerActions, dispatch),
        commonActions: bindActionCreators(commonActions, dispatch),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(MainInfoContainer));